import { motion } from "framer-motion";
import { BRAND } from "@/lib/brand";

const PLAYERS = [
  {
    handle: "Retired_Groat",
    role: "Captain · Rocket League",
    region: "NA-East",
    image: BRAND.players[0],
    stat: "92% aerial accuracy",
  },
  {
    handle: "master_ethan_2",
    role: "Sniper · Fortnite",
    region: "EU-West",
    image:
      "https://plus.unsplash.com/premium_photo-1661606237643-6511126a78db?fm=jpg&q=60&w=1600&auto=format&fit=crop",
    stat: "Top 0.1% earnings",
  },
  {
    handle: "GamerGirl",
    role: "Architect · Minecraft",
    region: "NA-West",
    image:
      "https://plus.unsplash.com/premium_photo-1683141334830-421d29aed85e?fm=jpg&q=60&w=1600&auto=format&fit=crop",
    stat: "Built TGL HQ Realm",
  },
];

export default function Roster() {
  return (
    <section
      id="roster"
      data-testid="roster-section"
      className="relative py-24 lg:py-32 bg-gradient-to-b from-[#050505] via-[#080604] to-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-14">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37]">
              ⌁ The Court
            </p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
              Meet The <span className="gold-text">Legends</span>
            </h2>
          </div>
          <a
            href="#contact"
            data-testid="roster-cta-tryouts"
            className="hidden md:inline-block text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37] border-b border-[#D4AF37]/40 hover:border-[#D4AF37] pb-1"
          >
            Open Tryouts →
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PLAYERS.map((p, i) => (
            <motion.div
              key={p.handle}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="tgl-card cut-corners group relative h-[28rem] overflow-hidden"
              data-testid={`roster-card-${p.handle.toLowerCase()}`}
            >
              <img
                src={p.image}
                alt={p.handle}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-90 grayscale group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />

              <div className="absolute top-4 left-4 right-4 flex justify-between">
                <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#F3E5AB] bg-black/60 border border-[#D4AF37]/30 px-2 py-1">
                  {p.region}
                </span>
                <span className="font-display text-xs font-black text-[#D4AF37]">
                  #{String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#D4AF37]">
                  {p.role}
                </p>
                <h3 className="mt-2 font-display text-3xl font-black uppercase text-white">
                  {p.handle}
                </h3>
                <div className="gold-divider my-3" />
                <p className="text-xs uppercase tracking-widest text-zinc-300">
                  {p.stat}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
